// wishlist-page.js

(function () {
  'use strict';

  const STORAGE_KEY = 'ic_wishlist';

  async function getList() {
    if (window.__IC_CUSTOMER__?.loggedIn) {
      try {
        const res = await fetch('/apps/wishlist-proxy');
        const data = await res.json();
        return data.wishlist || [];
      } catch { return []; }
    }
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch { return []; }
  }

  async function removeItem(productId) {
    if (window.__IC_CUSTOMER__?.loggedIn) {
      const list = await getList();
      const updated = list.filter(p => String(p.id) !== String(productId));
      await fetch('/apps/wishlist-proxy', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ wishlist: updated }),
      });
    } else {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(
        list.filter(p => String(p.id) !== String(productId))
      ));
    }

    const card = document.querySelector(`[data-wishlist-card-id="${productId}"]`);
    if (card) {
      card.style.transition = 'opacity 0.3s, transform 0.3s';
      card.style.opacity = '0';
      card.style.transform = 'scale(0.95)';
      setTimeout(() => { card.remove(); updateCount(); checkEmpty(); }, 300);
    }

    if (window.ICWishlist?.updateBadge) window.ICWishlist.updateBadge();
  }

  async function fetchRenderedCards(handles) {
    if (!handles.length) return '';
    const fetches = handles.map(handle =>
      fetch(`/products/${handle}?section_id=wishlist-grid`)
        .then(r => r.ok ? r.text() : '')
        .then(html => {
          if (!html) return '';
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const el = doc.querySelector('[id^="shopify-section-wishlist-grid"]');
          return el ? el.innerHTML : '';
        })
        .catch(() => '')
    );
    const results = await Promise.all(fetches);
    return results.join('');
  }

  function updateCount() {
    const grid    = document.getElementById('wl-grid');
    const countEl = document.getElementById('wl-count');
    if (!countEl || !grid) return;
    const n = grid.querySelectorAll('[data-wishlist-card-id]').length;
    countEl.textContent = n === 1 ? '1 item' : `${n} items`;
  }

  function checkEmpty() {
    const grid = document.getElementById('wl-grid');
    if (!grid) return;
    if (!grid.querySelectorAll('[data-wishlist-card-id]').length) {
      grid.style.display = 'none';
      const emptyEl = document.getElementById('wl-empty');
      if (emptyEl) emptyEl.style.display = 'flex';
      if (window.ICWishlist?.updateBadge) window.ICWishlist.updateBadge();
    }
  }

  function attachRemoveButtons() {
    document.querySelectorAll('[data-wishlist-remove]').forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        removeItem(btn.dataset.wishlistRemove);
      });
    });
  }

  function npcGoTo(slider, idx) {
    const imgs = slider.querySelectorAll('.npc-slide-img');
    if (imgs.length < 2) return;

    const current = parseInt(slider.dataset.index || '0');
    imgs[current]?.classList.remove('active');

    idx = (idx + imgs.length) % imgs.length;

    imgs[idx].classList.add('active');
    slider.dataset.index = idx;

    // const fill = slider.querySelector('.npc-progress-fill');
    const fill = slider.closest('.npc-new')?.querySelector('.npc-progress-fill');
    if (fill) {
      // fill.style.width = ((idx + 1) / imgs.length * 100) + '%';
      const segmentWidth = 100 / imgs.length;
      fill.style.width = segmentWidth + '%';
      fill.style.transform = `translateX(${idx * 100}%)`;
    }
  }

  function npcInitSlider(slider) {
    if (slider.dataset.npcInit) return;

    const imgs = slider.querySelectorAll('.npc-slide-img');
    if (imgs.length < 2) return;

    imgs.forEach(img => img.style.opacity = '');
    imgs[0].classList.add('active');

    slider.dataset.index = '0';
    slider.dataset.npcInit = '1';

    const bar = slider.closest('.npc-new')?.querySelector('.npc-progress-bar');
    if (bar && !bar.querySelector('.npc-progress-fill')) {
      const fill = document.createElement('div');
      fill.className = 'npc-progress-fill';
      // fill.style.width = (1 / imgs.length * 100) + '%';
      fill.style.width = (100 / imgs.length) + '%';
      fill.style.transform = 'translateX(0)';
      bar.appendChild(fill);
    }
  }

  function attachWishlistSliderButtons() {
    document.querySelectorAll('#wl-grid .npc-arrow').forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const slider = btn.closest('.npc-slider');
        if (!slider) return;

        const dir = btn.classList.contains('npc-arrow--prev') ? -1 : 1;
        npcGoTo(slider, parseInt(slider.dataset.index || '0') + dir);
      });
    });
  }

  async function render() {
    const loadingEl = document.getElementById('wl-loading');
    const emptyEl   = document.getElementById('wl-empty');
    const grid      = document.getElementById('wl-grid');
    if (!grid) return;

    const list = await getList();
    if (loadingEl) loadingEl.style.display = 'none';

    if (!list.length) {
      if (emptyEl) emptyEl.style.display = 'flex';
      return;
    }

    const countEl = document.getElementById('wl-count');
    if (countEl) countEl.textContent = list.length === 1 ? '1 item' : `${list.length} items`;

    const handles = list.map(p => p.handle).filter(Boolean);
    const cardsHTML = await fetchRenderedCards(handles);

    if (!cardsHTML.trim()) {
      if (emptyEl) emptyEl.style.display = 'flex';
      return;
    }

    const tmp = document.createElement('div');
    tmp.innerHTML = cardsHTML;

    // const wrappers = tmp.querySelectorAll('.npc-new-wrapper');
    // wrappers.forEach((wrapper, i) => {
    //   if (list[i]) wrapper.setAttribute('data-wishlist-card-id', list[i].id);
    // });

    grid.innerHTML = '';
    while (tmp.firstChild) grid.appendChild(tmp.firstChild);

    grid.style.display = 'grid';

    // Use the existing npcInitSlider — it's already global from product-card-scrollable
    // It runs on every .npc-slider that doesn't have data-npc-init yet
    grid.querySelectorAll('.npc-slider').forEach(npcInitSlider);
    attachWishlistSliderButtons();
    attachRemoveButtons();
  }

  if (document.getElementById('wl-grid')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', render);
    } else {
      render();
    }
  }

})();